const getOrganizationRecipient = ({ referrer, organization }) => {
    const { address } = organization;

    return {
        name: organization.name,
        address: [
            address?.lines.slice(0, 2).filter(l => l?.trim().length).join(', '),
            `${address?.lines.slice(2, 4).filter(l => l?.trim().length).join(', ') ?? ''} ${address?.postcode ?? ' '}`,
        ],
        email: referrer.email,
        contact: referrer.name,
        xeroContactId: organization.xeroContactId
    }
}

const getHmctsRecipient = () => {
    return {
        name: `HM Courts & Tribunals Service`,
        address: [`SSCL, PO Box 475, Newport`, `Gwent, NP10 8FZ`],
        email: `APinvoices-CTS-U@gov.sscl.com`,
        xeroContactId: '30e44179-a27b-42d5-8774-07d164b16aa7',
    }
}

const getSalesInvoiceRecipientInfo = ({ referrer, organization, tariff, items }) => {
    const recipient = {
        name: '',
        address: ['', ''],
        email: '',
        contact: ''
    };

    // if it's a family court case (tier1) or it's for attendance then invoice HMCTS
    if (isSalesInvoiceRecipientHMCTS({ tariff, items })) {
        recipient.name = `HM Courts & Tribunals Service`;
        recipient.address = [`SSCL, PO Box 475, Newport`, `Gwent, NP10 8FZ`];
        recipient.email = `APinvoices-CTS-U@gov.sscl.com`;
        recipient.xeroContactId = '30e44179-a27b-42d5-8774-07d164b16aa7';
    }
    else {
        // defendant assessment and report work is billed to solicitor firm
        const { address } = organization;

        recipient.name = organization.name;
        recipient.address = [
            address?.lines.slice(0, 2).filter(l => l?.trim().length).join(', '),
            `${address?.lines.slice(2, 4).filter(l => l?.trim().length).join(', ') ?? ''} ${address?.postcode ?? ' '}`,
        ];
        recipient.email = referrer.email;
        recipient.contact = referrer.name;
        recipient.xeroContactId = organization.xeroContactId;
    }

    return { ...recipient };
}

// tier1 is actually the family court jurisdiction
const isSalesInvoiceRecipientHMCTS = ({ tariff, items }) => (tariff.code === 'tier1' || items.find(({ section, code, quantity }) => section === 'attendance' && code !== 'conference' && quantity > 0));
// const isSalesInvoiceRecipientHMCTS = ({ tariff, items }) => !(tariff.code === 'defendant' && items.find(({ section, code, quantity }) => section === 'attendance' && code === 'conference' && quantity > 0));

const isRecipientAddressRequired = ({ organization, tariff, items = [] }) => {
    if (isSalesInvoiceRecipientHMCTS({ tariff, items })) return false;
    return !organization.address || !organization.address?.postcode || !organization.address?.lines[0];
}

export {
    getHmctsRecipient,
    getOrganizationRecipient,
    getSalesInvoiceRecipientInfo,
    isRecipientAddressRequired
}